import React, { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { useHasUpgradeSSCAccess } from '../../hooks/ssc/use-has-upgrade-ssc-access/use-has-upgrade-ssc-access';

const ScannersPage = lazy(() => import('./pages/scanners/scanners.page'));

const ScannersConfigPage = lazy(
  () => import('./pages/scanners-config/scanners-config.page'),
);

const ScannerInformationPage = lazy(
  () => import('./pages/scanner-information/scanner-information.page'),
);

const HostDnsServersPage = lazy(
  () => import('./pages/host-dns-servers/host-dns-servers.page'),
);

const ScanExclusionPage = lazy(
  () => import('./pages/scan-exclusion/scan-exclusion.page'),
);

const ScanningQueuePage = lazy(
  () => import('./pages/scanning-queue/scanning-queue.page'),
);

const ScanningSchedulePage = lazy(
  () => import('./pages/scanning-schedule/scanning-schedule.page'),
);

const CredentialedScanningPage = lazy(
  () => import('./pages/credentialed-scanning/credentialed-scanning.page'),
);

const ScannerUpgradeScheduleTab = lazy(
  () =>
    import('./pages/scanner-upgrade-schedule-tab/scanner-upgrade-schedule-tab'),
);

const NetworkConfigurationPage = lazy(
  () => import('./pages/network-configuration/network-configuration.page'),
);

const ShippingDetailsPage = lazy(
  () => import('./pages/shipping-details/shipping-details.page'),
);

const AddScannerPage = lazy(
  () => import('./pages/add-scanner/add-scanner.page'),
);

export const ScannersRoutes = () => {
  const hasUpgradeSSCAccess = useHasUpgradeSSCAccess();
  const [scannerConfigureActivateFF] = useFeatureFlag(
    'SCANNER_CONFIGURE_ACTIVATE',
  );

  return (
    <Routes>
      <Route index element={<ScannersPage />} />
      {scannerConfigureActivateFF && (
        <Route path="add" element={<AddScannerPage />} />
      )}
      <Route path=":scannerId" element={<ScannersConfigPage />}>
        <Route index element={<Navigate to="scannerInformation" replace />} />

        <Route path="scannerInformation" element={<ScannerInformationPage />} />

        <Route path="hostDnsServers" element={<HostDnsServersPage />} />

        <Route path="scanExclusion" element={<ScanExclusionPage />} />

        <Route path="scanningQueue" element={<ScanningQueuePage />} />

        <Route path="scanningSchedule" element={<ScanningSchedulePage />} />

        <Route
          path="credentialedScanning"
          element={<CredentialedScanningPage />}
        />
        {scannerConfigureActivateFF && (
          <>
            <Route
              path="networkConfiguration"
              element={<NetworkConfigurationPage />}
            />

            <Route path="shippingDetails" element={<ShippingDetailsPage />} />
          </>
        )}

        {hasUpgradeSSCAccess && (
          <Route
            path="scannerUpgradeSchedule"
            element={<ScannerUpgradeScheduleTab />}
          />
        )}
      </Route>
    </Routes>
  );
};
